import { client } from "@/lib/api";

export async function getCookieStatus() {
  const { data } = await client.get("/settings/catawiki-cookie");
  return data;
}

export async function saveCookie(cookie) {
  const { data } = await client.post("/settings/catawiki-cookie", { cookie });
  return data;
}

export async function deleteCookie() {
  const { data } = await client.delete("/settings/catawiki-cookie");
  return data;
}

export async function testCookie() {
  const { data } = await client.get("/settings/catawiki-cookie/test", { timeout: 30000 });
  return data;
}
